import React from 'react';
import { reducer, CacheOptions } from './CachingReducer';

export interface Cache {
  [propName: string]: unknown;
}

interface Store {
  cache: Cache;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getCache: (key?: string) => any;
  setCache: (key: string, value: unknown) => void;
  clearCache: (key?: string) => void;
}

const localState = localStorage.getItem('cache');
const sessionState = sessionStorage.getItem('cache');
const defaultState = {
  ...(sessionState ? JSON.parse(sessionState) : {}),
  ...(localState ? JSON.parse(localState) : {}),
};

const CacheContext = React.createContext<Store>({
  cache: defaultState,
  getCache: () => undefined,
  setCache: () => undefined,
  clearCache: () => undefined,
});

export const useCache: () => Store = () => React.useContext<Store>(CacheContext);

export const CacheProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const [state, dispatch] = React.useReducer(reducer, defaultState);

  const getCache = (key?: string): unknown => {
    if (key) return state[key];
    else return state;
  };

  const setCache = (key: string, value: unknown): void => {
    dispatch({ type: CacheOptions.SET_STATE, payload: { [key]: value } });
  };

  const clearCache = (key?: string): void => dispatch({ type: CacheOptions.CLEAR_STATE, payload: key });

  const context = {
    cache: state,
    getCache: getCache,
    setCache: setCache,
    clearCache: clearCache,
  };

  return <CacheContext.Provider value={context}>{children}</CacheContext.Provider>;
};
